import * as React from 'react';
import bindAllOfThis from 'src/utils/BindThisHelper';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/RocketRepairGame/scenes/GameIntro';

interface PhaserRocketRepairGameProps {
    onComplete: () => void;
}

interface PhaserRocketRepairGameState {
}

const gameConfig: GameConfig = {
    title: "Rocket Repair Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};

class PhaserRocketRepairGame extends React.Component<PhaserRocketRepairGameProps, PhaserRocketRepairGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserRocketRepairGameProps) {
        super(props);
        bindAllOfThis(this, PhaserRocketRepairGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete}/>
        </div>);
    }
}

export default PhaserRocketRepairGame;



// WEBPACK FOOTER //
// ./src/games/RocketRepairGame/Main.tsx